import BankWatchDashboardService from '@/services/bankwatch/DashboardService';

const dashboardService = new BankWatchDashboardService();

export const getSummary = async ({ commit }: { commit: Function }, payload: any) => {
    commit('isFetchingSummary', true);
    commit('summaryError', '');
    try {
        const summary = await dashboardService.getSummary(payload.selectedMonth);
        commit('summary', summary);
    } catch (err: any) {
        commit('summaryError', err?.message || 'Failed to load dashboard.');
    } finally {
        commit('isFetchingSummary', false);
    }
}

export const getUserDetail = async (_ctx: any, payload: any) => {
    return await dashboardService.getUserDetail(payload.userId);
}

export const getGroupBrokers = async (_ctx: any, payload: any) => {
    return await dashboardService.getGroupBrokers(payload.groupId);
}
